<template>

  <div class="card h-100">
    <b-card
      :img-src="require('@/assets/images/pages/inicio/banner-home-profesores.jpg')"
      alt="Responsable de materia - Campus Virtual Indetec"
      img-top
      img-height="100"
      class="card-profile"
      style="margin-bottom: 0px;"
    >
      <div class="profile-image-wrapper">
        <div class="profile-image p-1">
          <b-avatar
            size="140"
            variant="light-secondary"
            :alt="'Responsable de materia - Campus Virtual Indetec -' + perfilPromoProfesor.picprofile"
            :src="perfilPromoProfesor.picprofile ? `${delivery}${perfilPromoProfesor.picprofile}` : ''"
          />
        </div>
      </div>
      <h3>{{ perfilPromoProfesor.titulo }}</h3>
      <b-badge
        class="profile-badge"
        variant="light-primary"
      >
        {{ perfilPromoProfesor.subtitulo }}
      </b-badge>
      <b-badge
        class="profile-badge"
        :variant="`light-${perfilPromoProfesor.plan === 1? 'secondary' : 'warning' }`"
      >
        {{ perfilPromoProfesor.nplan }}
      </b-badge>
      <hr class="mb-2">
      <div class="d-flex justify-content-between align-items-center">
        <p class="text-justify">
          {{ perfilPromoProfesor.descripcionCorta }}
        </p>
      </div>
      <b-card-footer class="m-0">
        <b-button
          v-b-modal="`modalp-${perfilPromoProfesor.titulo}-${perfilPromoProfesor.id}`"
          variant="outline-primary"
          pill
        >
          Leer más
        </b-button>
      </b-card-footer>
      <modal-perfil
        :data="[perfilPromoProfesor]"
        :idm="'modalp'"
      />
    </b-card>

  </div>
</template>
<script>
import {
  BCard, BBadge, BAvatar, BButton, BCardFooter,
} from 'bootstrap-vue'
import ModalPerfil from '../oferta-academica/modal-card-academica.vue'

export default {
  components: {
    BCard,
    BBadge,
    BAvatar,
    BButton,
    BCardFooter,
    ModalPerfil,
  },
  props: {
    perfilPromoProfesor: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const delivery = process.env.VUE_APP_DELIVERY_DOWNLOAD
    return {
      delivery,
    }
  },
}
</script>
<style lang="css">
.profile-image img {
    width: 160px !important;
    height: 160px !important;
}
[dir] .card-profile .card-body {
    padding: 10rem 2.3rem 0 2.3rem !important;
}
</style>
